import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';
import { stringify } from 'query-string'
import withHooks from 'cityads-v3/decorators/withHooks'
import { useThemeChanger } from 'cityads-v3/hooks/theme'
import config from 'cityads-v3/config';

import {
  getTrustLevels,
} from 'cityads-v3/actions/trustLevels';

import {
  loadWebmasterInfo,
  loadWebmasterAdditionalData,
} from 'cityads-v3/actions/welcomeform';

import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import PermContactCalendarOutlinedIcon from '@mui/icons-material/PermContactCalendarOutlined'
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined'
import SubscriptionsOutlinedIcon from '@mui/icons-material/SubscriptionsOutlined';


import Alert from '@mui/material/Alert' /** @todo перенести на v5 */
import AuthIFrame from 'cityads-v3/containers/Auth/AuthIFrame';
import Balaclava from 'cityads-v3/components/Balaclava';
import { Helmet } from 'react-helmet';
import PageWithMenu from 'cityads-v3/components/PageWithMenu';
import Typography from '@mui/material/Typography';

import FormPhone from './FormPhone';
import FormPersonal from './FormPersonal';
import FormSubscriptions from './FormSubscriptions';
import Form, {
  FORM_KIND_SECURITY,
  FORM_KIND_PERSONAL,
  FORM_KIND_TRAFFIC,
  FORM_KIND_GEO,
  FORM_KIND_SUBSCRIPTIONS,
} from './Form';
import Step3 from 'cityads-v3/containers/welcomeform/Step3';
import Step4 from 'cityads-v3/containers/welcomeform/Step4';

import classes from './Account.scss';

const HEADER_OFFSET = 16;

@connect(
  state => ({
    user               : state.auth.user || {},
    language           : state.language.language,
    verificationStatus : state.header.user?.verificationStatus ?? null,

    isLoadedTrustLevels: state.trustLevels.isLoaded,

    isPatchingProfile: state.welcomeform.isPatchingForm.profile,

    isLoadingWebmasterInfoForm       : state.welcomeform.isLoadingWebmasterInfoForm,
    isLoadingWebmasterAdditionalForm : state.welcomeform.isLoadingWebmasterAdditionalForm,
  })
)
@withHooks(props => ({
  ...props,
  themeChanger: useThemeChanger()
}))
@withTranslation(['Welcome', 'main'], { i18n, wait: false })
export default class Account extends Component {

  static propTypes = {
    language: PropTypes.string,
  }

  componentDidMount() {
    const { dispatch } = this.props;

    if (!this.props.isLoadedTrustLevels) {
      dispatch(getTrustLevels());
    }
    this.loadWebmasterForms();
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const { dispatch, user, language } = newProps;
    const oldProps = this.props;

    if (!oldProps.user.id && user.id) {
      this.loadWebmasterForms(newProps);
    }

    if (oldProps.language !== language) {
      dispatch(getTrustLevels());
    }
  }

  loadWebmasterForms(props = this.props) {
    const { dispatch, user, isLoadingWebmasterInfoForm, isLoadingWebmasterAdditionalForm } = props;

    if (user.id && !isLoadingWebmasterInfoForm) {
      dispatch(loadWebmasterInfo(user.id));
    }
    if (user.id && !isLoadingWebmasterAdditionalForm) {
      dispatch(loadWebmasterAdditionalData(user.id));
    }
  }

  getOffset() {
    if (window) {
      const headerEl = window.document.getElementById('header');
      return headerEl ? -headerEl.offsetHeight - HEADER_OFFSET : 0;
    }

    return 0;
  }

  render() {
    const { language, t, verificationStatus, isPatchingProfile, themeChanger } = this.props

    const passwordChangeSrc = `${config.AUTH_URL}/change/password?`
      + stringify({
        theme: 'material',
        lang: language,
        dark_mode: themeChanger.theme.palette.mode === 'dark' ? true : undefined
      })

    return (
      <>
        <Helmet>
          <title>{t('main:header.my_account')}</title>
        </Helmet>

        <Balaclava
          title = {t('main:header.my_account')}
        />

        <PageWithMenu
          menuItems = {[
            {
              key  : FORM_KIND_SECURITY,
              icon : <LockOutlinedIcon />,
              title: t('security'),
            },
            {
              key  : FORM_KIND_PERSONAL,
              icon : <PermContactCalendarOutlinedIcon />,
              title: t('account.step2'),
            },
            {
              key  : FORM_KIND_TRAFFIC,
              icon : <ConfirmationNumberOutlinedIcon />,
              title: t('account.step3'),
            },
            {
              key  : FORM_KIND_GEO,
              icon : <PublicOutlinedIcon />,
              title: t('step4'),
            },
            {
              key  : FORM_KIND_SUBSCRIPTIONS,
              icon : <SubscriptionsOutlinedIcon />,
              title: t('subscriptions'),
            },
          ]}
        >
          <Form
            title = {t('security')}
            showButtons={false}
            formKind = {FORM_KIND_SECURITY}
            data-page-menu-key   = {FORM_KIND_SECURITY}
            data-page-menu-icon  = {<LockOutlinedIcon />}
            data-page-menu-title={t('security')}
            sx={{ padding: '0' }}
          >
            <div className={classes.security}>
              <AuthIFrame src={passwordChangeSrc} title={t('security')} className={classes.changePasswordFrame} />
              <FormPhone className={classes.phoneForm} />
            </div>
          </Form>

          <Form
            saveButtonTitle = {t('account.sendToVerification')}
            saveButtonDisabled = {verificationStatus === 1}
            isPatchingForm = {isPatchingProfile}
            fields = {[
              'name', 'contacts', 'birthday', 'company', 'domain',
              'categories', 'geo', 'offer_type_directions', 'traffic_type', 'traffic_subtypes', 'traffic_type_url', 'work_experience',
              'country', 'timezone',
            ]}
            formKind = {FORM_KIND_PERSONAL}
            data-page-menu-key = {FORM_KIND_PERSONAL + FORM_KIND_TRAFFIC + FORM_KIND_GEO}
          >
            <div>
              <div id={FORM_KIND_PERSONAL}>
                <Typography variant="h5" className={classes.formHeader}>
                  {t('account.step2')}
                </Typography>

                <FormPersonal/>
              </div>

              <div id={FORM_KIND_TRAFFIC}>
                <Typography variant="h5" className={classes.formHeader}>
                  {t('account.step3')}
                </Typography>

                <Step3
                  inline
                  inlineClasses={{
                    root: classes.inlineRoot,
                    formItems: classes.formItems
                  }}
                />
              </div>

              <div id={FORM_KIND_GEO}>
                <Typography variant="h5" className={classes.formHeader}>
                  {t('step4')}
                </Typography>

                <Step4
                  inline
                  inlineClasses={{
                    root: classes.inlineRoot,
                    formItems: classes.formItems
                  }}
                />
              </div>

              <Alert severity="info" className={classes.formHint}>
                {t('account.verificationHint')}
              </Alert>
            </div>
          </Form>

          <FormSubscriptions
            title = {t('subscriptions')}
            data-page-menu-key   = {FORM_KIND_SUBSCRIPTIONS}
            data-page-menu-icon  = {<SubscriptionsOutlinedIcon />}
            data-page-menu-title = {t('subscriptions')}
          />
        </PageWithMenu>
      </>
    );
  }

}
